 <template>
    <div class="container">
        <div class="content">
            <img class="tip_icon" src="../assets/images/guagua_title.png" alt="">
            <div class="guagua_box" id="gua_box" :style="frameW">
                <div class="canvas_box" v-if="canvasShow">
                    <canvas id="canvas_bg" :style="frameW"></canvas>
                </div>
                <div class="layFirst" v-if="newStatus" :style="btnTop">
                    <div class="showjf" v-if="lotteryDetail.user_have_credit">{{'我的积分:'+lotteryDetail.user_have_credit}}</div>
                    <div class="startGua clickH lottery-draw" @click="isClickPrize?getPrizeName():''">
                        <p :style="lotteryDetail.credit_desc==''?'line-height:40px':''">点我刮奖</p>
                        <p class="descFont" v-if="lotteryDetail.credit_desc!=''">{{lotteryDetail.credit_desc}}</p>
                    </div>
                </div>
                <div class="gift_text">
                    <p class="gif_name">{{getPrize.prize_name || "谢谢参与"}}</p>
                    <p :class="clickOne?'startGua':'startGuaEnd'" v-if="getPrize.prize_id!='0'&&getPrize.prize_type=='1'&&getPrize.receive_msg.length!='0'" @click="clickOne?clickGet():''">{{clickOne?'填写信息':'奖品待发放'}}</p>
                    <p :class="clickOne?'startGua':'startGuaEnd'" v-if="getPrize.prize_id!='0'&&getPrize.prize_type=='2'" @click="clickOne?clickGet():''">{{clickOne?'查看奖品':'已领取'}}</p>
                    <p :class="clickOne?'startGua':'startGuaEnd'" v-if="getPrize.prize_id!='0'&&getPrize.prize_type=='1'&&getPrize.receive_msg.length=='0'" @click="clickOne?clickGet():''">{{clickOne?'查看奖品':'奖品待发放'}}</p>
                    <a class="startGua" v-if="getPrize.prize_id!='0' && getPrize.prize_type==3 && getPrize.prize_url" :href="getPrize.prize_url">立即领取</a>
                </div>
            </div>
            <!-- 刮奖状态 -->
            <button :class="is_change?'press_btn':'no_press_btn'" @click="is_change?guajiang():''">再来一次</button>
            <!-- no_limit为1代表无限制 -->
            <div v-if="residueCount && residueCount.no_limit != '1' && is_change">{{'您还剩余'+residueCount.residue_count+'次刮奖机会'}}</div>
            <!-- 抽奖次数大于0时不显示 -->
            <div v-if="!is_change">刮奖机会用完啦！</div>
            <div class="award_btn" @click="clickAward">
               <p>我的中奖记录</p>
            </div>
        </div>
        <section class="tip_text_container" v-if="lotteryDetail.show_desc=='1'"><!-- 奖品说明 -->
            <div class="tip_award">
                <p>奖项说明</p>
            </div>
            <div class="awardList">
                <ul class="lists">
                    <li class="list" v-for="(item,index) in prizeListData" :key="index">
                        <p class="awardPic" v-if="prizeListImgDisplay">
                            <img :src="item.image" alt="">
                        </p>
                        <p :class="prizeListImgDisplay?'pName':'pName_sec'">{{item.name}}</p>
                        <p :class="prizeListImgDisplay?'pDesc':'pDesc_sec'">{{item.desc}}</p>
                        <p :class="prizeListImgDisplay?'pSur':'pSur_sec'" v-if="lotteryDetail.show_prize_num=='1'">{{'剩余数量：'+item.prize_number}}</p>
                        <p v-if="!prizeListData.length">发布者暂时没有配置奖项</p>
                    </li>
                </ul>
            </div>
        </section>
        <section class="tip_text_container"><!-- 活动说明 -->
            <div class="tip_award">
                <p>活动说明</p>
            </div>
            <div class="awardList">
                <div class="lists" v-if="lotteryDetail.about_lottery">
                    <p class="explain">
                      <pre>{{lotteryDetail.about_lottery}}</pre>
                    </p>
                </div>
                <div class="lists" v-else>
                    <p class="explain" v-html="lotteryDetail.desc"></p>
                </div>
            </div>
        </section>
        <section class="foot">
            <div class="logo">
                <img :src="logo_img" alt="">
            </div>
        </section>

        <el-dialog :title="getPrize.msg" :visible.sync="dialogFillIn" center :show-close="false" class="dialog_input">
          <el-form :model="fillInfo" :label-width="formLabelWidth">
            <el-form-item label="姓名" v-show="judge.name">
              <el-input v-model="fillInfo.nickname"></el-input>
            </el-form-item>
            <el-form-item label="手机号码" v-show="judge.tel">
              <el-input v-model="fillInfo.telephone"></el-input>
            </el-form-item>
            <el-form-item label="身份证" v-show="judge.idcard">
              <el-input v-model="fillInfo.idcard"></el-input>
            </el-form-item>
            <el-form-item label="邮寄地址" v-show="judge.add">
              <el-input type="textarea" v-model="fillInfo.address"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button @click="dialogFillIn = false">取 消</el-button>
            <el-button type="primary" class="pop_btn" @click="validSubmit?formSure():''">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 实物中奖弹窗 -->
        <formDialog
            :formDialogDisplay.sync="formDialogDisplay"
            :title="getPrize.msg"
            :id="getPrize.prize_receive_record_id"
            :formList="fillInfo"></formDialog>
    </div>
</template>

<script>
import { getDrawPrize } from '@/api'

import FormDialog from 'components/formDialog/formDialog'

import {logo_img} from '../config/config';
    export default {
      data() {
        return {
          logo_img,
          formDialogDisplay: false,
          isClickPrize:true,
          clickOne:true,
          getOrUse:'',
          s_width:'',
          s_height:'',
          canvasShow:true,
          mousedown:false,
          ctx:'',
          canvas_h:'',
          canvas_w:'',
          mycanvas:'',
          is_change:true,
          getPrize: '',
          newStatus:true,
          touch_end:{},
          touch_start:{},
          touch_dev:'',
          // dialogTip:false,
          residueCount: null,
          formLabelWidth:'25%',
          dialogFillIn:false,
          fillInfo:{},
          fields:{},
          judge:{
              name:false,
              tel:false,
              idcard:false,
              add:false
          },
          validSubmit:true,
        }
      },
      inject: ['reload'],
      props: ['lotteryDetail','prizeListData', 'preview', 'platRight', 'prizeListImgDisplay', 'coordinate'],
        created() {
          this.s_width = document.body.clientWidth;
          this.s_height = document.body.clientHeight;
          this.initdrawnum();
        },
        mounted(){
            this.canvas_h = document.getElementById("canvas_bg").offsetHeight;
            this.canvas_w = document.getElementById("canvas_bg").offsetWidth;
            this.mycanvas =document.querySelector("canvas");

            this.mycanvas.width = this.canvas_w;
            this.mycanvas.height = this.canvas_h;
            this.ctx=this.mycanvas.getContext('2d');
            // this.ctx.fillRect(0, 0, this.canvas_w, this.canvas_h);
            this.layer(this.ctx);
            this.ctx.globalCompositeOperation = 'destination-out';
            this.mycanvas.addEventListener('touchstart', this.eventDown);
            this.mycanvas.addEventListener('touchend', this.eventUp);
            this.mycanvas.addEventListener('touchmove', this.eventMove);
        },
        computed: {
            themeColor(){//主题色
                return {
                    backgroundColor:"#ccc"
                }
            },
            frameW(){
                let box_w = (705*this.s_width)/750;
                let box_h = (353*this.s_height)/1334;
                return{
                  width:box_w+'px'||'300px',
                  height:box_h+'px'||'128px'
                }
            },
            btnTop(){
                let _this = this;
                let box_h = (353*_this.s_height)/1334;
                let padTop;
                if (_this.lotteryDetail.credit!='0') {
                    padTop=box_h/2-40
                }else{
                    padTop=box_h/2-20
                }
                return{
                    paddingTop:padTop+'px'
                }
            }
        },
        methods: {
          initdrawnum() {
              let latitude, longitude
              if (this.coordinate) {
                latitude = this.coordinate.latitude
                longitude = this.coordinate.longitude
              }
              const vm = this
              this.Get({
                url:'/activity/api.php',
                data: {
                  m:'front',
                  subm:'lottery',
                  action:'drawnum',
                  preview: this.preview,
                  lat: latitude || '',
                  lng: longitude || '',
                },
                success:function(data) {
                  console.log('scratchCard drawnum', data)
                  vm.residueCount = data.data;
                  vm.is_change = vm.residueCount.residue_count ? true : false
                }
              });
          },
          platRightCheck() {
            if (this.platRight && this.platRight.right === 0) {
              if (this.platRight.apptype === 'WX') {
                this.$router.push('/wxScan')
              } else {
                this.$dialog({
                  message: this.platRight.name,
                  url: this.platRight.url,
                  key: this.platRight.apptype
                })
              }
              return true
            }
          },
            layer(ctx){
                let w = this.canvas_w*0.9;
                let h = this.canvas_h*0.75;
                let ds_left = (this.canvas_w-this.canvas_w*0.9)/2;
                let ds_top = (this.canvas_h-this.canvas_h*0.75)/2;

                ctx.fillStyle = '#b4b4b4'; //刮刮卡上面那层灰色的
                ctx.fillRect(ds_left, ds_top, w, h);
                ctx.font = "20px Arial";
                ctx.fillStyle = "#fff";//刮奖处文字颜色
                //从坐标点(50,50)开始绘制文字
                ctx.fillText("刮奖处",this.canvas_w/2.5,this.canvas_h/1.8);
            },
            eventDown(e){
                e.preventDefault();
                let _this = this;
                _this.mousedown=true;
                let tc = e.touches[0];
                _this.touch_start.x = parseInt(tc.pageX);
                _this.touch_start.y = parseInt(tc.pageY);
            },
            eventUp(e){
                e.preventDefault();
                let _this = this;
                _this.mousedown=false;
                let x = Math.abs(_this.touch_end.x -_this.touch_start.x);
                if (x&&x>10) {
                    _this.canvasShow = false;
                }
            },
            eventMove(e){
                e.preventDefault();
                let _this = this;
                if(_this.mousedown){
                    if(e.changedTouches){
                        e=e.changedTouches[e.changedTouches.length-1];
                    }
                    let x = (e.clientX + document.body.scrollLeft || e.pageX) - document.getElementById("gua_box").offsetLeft || 0;
                    let y = (e.clientY + document.body.scrollTop || e.pageY) - document.getElementById("gua_box").offsetTop || 0;
                    _this.ctx.beginPath();
                    _this.ctx.arc(x, y, 20, 0, Math.PI * 3);
                    _this.ctx.fill();
                }
                _this.touch_end.x = parseInt(e.pageX);
                _this.touch_end.y = parseInt(e.pageY);
            },
            drawAward(){
                const param = {
                    preview: this.preview,
                }
                let _this = this;
                let latitude, longitude
                if (this.coordinate) {
                  latitude = this.coordinate.latitude
                  longitude = this.coordinate.longitude
                  param.lat = latitude
                  param.lng = longitude
                }
                getDrawPrize(param).then(data => {
                    this.initdrawnum();
                    console.log('getDrawPrize', data)
                    if (data.code === 3001 || data.code==5124) {
                        this.getPrize = data.data;
                        this.newStatus = false;
                        // 非无限抽奖次数时更新剩余抽奖次数
                        // this.residueCount.residue_count = this.getPrize.residue_count;
                        // this.is_change = this.getPrize.residue_count ? true : false
                    } else if (data.code==5023 || data.code==5012 || data.code==5108 || data.code==5026) {
                        this.alertPrize(data.msg);
                        this.isClickPrize = true;
                    } else if (data.code==5007||data.code == 5110||data.code==5011||data.code==5013||data.code==5014||data.code==5020||data.code==5107) {
                        this.alertPrize(data.msg);
                        this.isClickPrize = true;
                    } else if (data.code==5009 || data.code==5025) {
                        this.$message({
                            type: 'error',
                            message: data.msg,
                            center:true,
                            onClose:function(){
                              _this.isClickPrize = true;
                            }
                        });
                    }
                }).catch(err => {
                    this.initdrawnum();
                    console.log('getDrawPrize err', err)
                })
            },
            guajiang() {
                this.reload()
            },
            getPrizeName() {
              // 端检查
              if (this.platRightCheck()) return
              this.isClickPrize = false;
              this.clickOne = true;
              this.drawAward();
            },
            clickGet(){
                let _this = this;
                if (_this.getPrize.prize_type=='1'&&_this.getPrize.receive_msg.length!='0') {//获得实物
                    for(let i=0;i<this.getPrize.receive_msg.length;i++){
                        let item = this.getPrize.receive_msg[i]
                        this.fillInfo[item] = ''
                    }
                    // _this.dialogFillIn= true;
                    // 实物中奖弹窗
                    this.formDialogDisplay = true
                }else{
                    _this.clickOne = false;
                    let msgInfo;
                    if (_this.getPrize.invented_prize_info.verification) {
                        msgInfo =_this.getPrize.msg+'<br>'+_this.getPrize.invented_prize_info.verification;
                    }else{
                        msgInfo = _this.getPrize.msg;
                    }
                    _this.alertPrize(msgInfo);
                }
            },
            clickAward() {
              // 端检查
              if (this.platRightCheck()) return
              this.$emit('clickAward')
            },
            alertPrize(){//中奖后的弹框
              this.$emit.apply(this,[].concat.apply(['alertPrize'], arguments));
            }
        },
        components: {
            FormDialog
        }
    }
</script>
<style scoped>
    .guagua_box{
        width: 14.25rem;
        height: 6.875rem;
        background-color: #fff;
        background-image: url('../assets/images/gua.png');
        background-size: 100% 100%;
        margin: 0 auto;
        background-color: #ffd61a;
        position: relative;
    }
    .canvas_box{
        width: 100%;
        height: 100%;
    }
    .layFirst{
        width: 100%;
        height: 100%;
        position: absolute;
        top: 0px;
        /*background-color: #000000b0;*/
        z-index: 99;
    }
    .showjf{
        color: #fff;
        margin-bottom: 1%;
    }
    .startGua{
        background-color: #e94716;
        color: #fff;
        padding: 2% 1%;
        border-radius: 5px;
        width: 30%;
        -webkit-box-shadow: 0px 3px 1px #ad2902;
        box-shadow: 0px 3px 1px #ad2902;
        margin: 0 auto;
    }
    .startGuaEnd{
        background-color: #b5b2b1;
        color: #fff;
        padding: 2% 1%;
        border-radius: 5px;
        width: 30%;
        -webkit-box-shadow: 0px 3px 1px #ad2902;
        box-shadow: 0px 3px 1px #b3adab;
        margin: 0 auto;
    }
    .descFont{
        font-size: 12px;
    }
    .clickH{
        min-height: 40px;
    }
    canvas#canvas_bg{
        width: 14.25rem;
        height: 6.875rem;
        position: absolute;
        left: 0px;
        z-index: 99;
    }
    .gift_text{
        width: 100%;
        /*height: 100%;*/
        position: absolute;
        top: 35%;
        text-align: center;
    }
    .gift_text a{
      display: block;
      text-decoration: none;
    }
    .press_btn{
        border: none;
        background: none;
        background-color: #e94716;
        color: #fbd915;
        padding: 2% 5%;
        border-radius: 5px;
        margin-top: 5%;
        margin-bottom: 3%;
        box-shadow: 0px 3px 1px #ad2902;
    }
    .no_press_btn{
        border: none;
        background: none;
        background-color: #9a9c9b;
        color: #fff;
        padding: 2% 5%;
        border-radius: 5px;
        margin-top: 8%;
        /*box-shadow: 0px 3px 1px #ad2902;*/
    }
</style>



// WEBPACK FOOTER //
// src/components/scratchCard.vue